import { gql } from "@/services/httpAdapter";

const SaleInvoiceTotalsFragment = gql`
	fragment SaleInvoiceTotals on SaleInvoiceTotals {
		position
		employeeId
		initialChargeableFrontEndGross
		initialChargeableBackEndGross
		remainingChargeableFrontEndGross
		remainingChargeableBackEndGross
	}
`;

const VehicleInformationFragment = gql`
	fragment VehicleInformation on VehicleInformation {
		make
		model
		modelYear
	}
`;

const InvoiceFragment = gql`
	fragment Invoice on Invoice {
		_id
		accountNumber
		invoiceDate
		invoiceType
		invoiceAmount
		invoiceCycleId
		invoicePayPeriodId
		controlNumber
		referenceNumber
		provider
		employeeId
		employeeName
		processor
		addedBy
		isValidCode
		isValidEmployee
		createdAt
	}
`;

const SaleInvoiceFragment = gql`
	fragment SaleInvoice on SaleInvoice {
		_id
		locationId
		commissionCycleId
		payPeriodId
		saleDate
		saleType
		saleGross
		saleAdjustable
		dealNumber
		stockNumber
		vehicleInformation {
			...VehicleInformation
		}
		customerName
		customerNumber
		invoices {
			...Invoice
		}
		runningTotals {
			...SaleInvoiceTotals
		}
		units
		invoiceAmount
		isValidEmployee
		isValidChargeback
		dateOutOfRange
		createdAt
	}
	${VehicleInformationFragment}
	${InvoiceFragment}
	${SaleInvoiceTotalsFragment}
`;

export { InvoiceFragment, SaleInvoiceFragment };
